import React, { useMemo } from 'react';
import KanbanColumn from './KanbanColumn';
import OperationCard from '../OperationCard';

/**
 * Columna "Rechazadas" — agrupa solicitudes en estado `Rechazada`.
 *
 * Archivo independiente para que se pueda modificar sin tocar
 * las otras 3 columnas (Cotizaciones, EnCurso, Finalizadas).
 */
const RechazadasColumn = ({ items = [], onAction, loading = false, headerExtra, actionsMode = 'full' }) => {
  const renderItem = useMemo(
    () => (r) => <OperationCard r={r} variant="rechazadas" onAction={onAction} actionsMode={actionsMode} />,
    [onAction, actionsMode],
  );

  return (
    <KanbanColumn
      id="rechazadas"
      title="Rechazadas"
      accent="border-t-rose-500"
      badge="bg-rose-100 text-rose-800 border-rose-200"
      items={items}
      renderItem={renderItem}
      loading={loading}
      emptyText="Sin solicitudes rechazadas"
      headerExtra={headerExtra}
    />
  );
};

export default RechazadasColumn;
